import { render, staticRenderFns } from "./consultationDetail.vue?vue&type=template&id=9c404efa&"
import script from "./consultationDetail.vue?vue&type=script&lang=js&"
export * from "./consultationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports